import { dayjs } from "@eroad/helpers/dayjs";

/**
 * Returns the user's timezone if it can't be determined from the browser's Intl.
 */
function guessTimeZone(): string {
  return dayjs.tz.guess();
}

export { guessTimeZone };
